<template>
  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-btn
          class="zoom-hover"
          v-bind="computedProps"
          v-on="$listeners">
          <slot></slot>
        </v-btn>
      </span>
      <v-btn
        v-else
        class="zoom-hover"
        v-bind="computedProps"
        v-on="$listeners">
        <slot></slot>
      </v-btn>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import { VBtn } from 'vuetify/lib'

/**
 * @file DDv2用標準フッターボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @example
  <dd-footer-button
    [atmark]lick="DdFooterButtonOnClick">
    CSV出力
  </dd-footer-button>
 */
export default {
  name: 'DdFooterButton',
  extends: VBtn,
  props: {
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
  }),
  mounted: function () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        text: true,
        outlined: true,
        rounded: true,
        dark: true,
        elevation: 2,
        class: ' mx-5',
        minWidth: 100,
        style: { background: controls.Colors.ButtonFooterBackground }
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
i::before {
  color: #1976d2 !important;
}
</style>
